var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45918 13.7307C1.48249 13.6625 1.56809 13.6406 1.62128 13.6892L4.40415 16.2337C4.45953 16.2843 4.44149 16.3756 4.37102 16.4014L0.196715 17.928C0.117738 17.9569 0.0405454 17.8813 0.0677426 17.8018L1.45918 13.7307Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4858 3.51724L5.14294 15.7931L2.26294 12.8966L14.6058 0.62069C15.4287 -0.206897 16.6629 -0.206897 17.4858 0.62069C18.1715 1.31034 18.1715 2.68966 17.4858 3.51724Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.9b37f89f0a43897c3603e7bfd4b50bae.svg";
export { ForwardRef as ReactComponent };